import { BasicPage } from "../../theme/Component/BasicPage"

export const DevueltosImp =()=>{
    return(
        <h4>Devueltos</h4>
    )
}